var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import classNames from 'classnames';
import { translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
// md3: MUI Tabs/Tab -> the md3.css `.st-tabs`/`.st-tab` underline tab bar (plain buttons);
// TabPanel is the design-neutral panel, now in the autobahn compat package.
import { TabPanel } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Skeleton } from '@bytebrand/fe-ui-core-autobahn/ui';
import Page from '../../containers/Page';
import { GENDERS, TITLES } from '../../../framework/constants/profile';
import CredentialsForm from './forms/CredentialsForm';
import ContactDetailsForm, { saveAccountBaseline, clearAccountBaseline } from './forms/ContactDetailsForm';
import DataUsageForm from './forms/DataUsageForm';
import PrivateAddressForm from '../SettingsPage/forms/PrivateAddressForm';
import DeliveryAddressForm from '../SettingsPage/forms/DeliveryAddressForm';
import ProfileTabAccountNext from './Profile/ProfileTabAccountNext';
import ProfileTabSecurityNext from './Profile/ProfileTabSecurityNext';
import ProfileTabAddress from './Profile/ProfileTabAddress';
import ProfileTabDataUsageNext from './Profile/ProfileTabDataUsageNext';
import ProfileAddressModal from './Profile/ProfileAddressModal';
import { Icon as MIcon } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './SettingsPage.styl';
import breadcrumbChevron from './icons/breadcrumb-chevron.svg';
import breadcrumbChevronSm from './icons/breadcrumb-chevron-sm.svg';
import './ProfilePage.css';
let SettingsPage = class SettingsPage extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "tabsRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: React.createRef()
        });
        Object.defineProperty(this, "setValuesInFormFieldsOnInit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, profile) => {
                const values = form.values();
                Object.keys(values).forEach((parentFieldName) => {
                    Object.keys(values[parentFieldName]).forEach((key) => {
                        let value = _get(profile, [parentFieldName, key], null);
                        // set value only if it's not empty
                        // checkAvailabilityGender(value) <-- this condition for 'title' or 'gender' field
                        if (value || value === 0) {
                            // Special cases for dropdown genre value
                            if (key === 'gender') {
                                value = GENDERS[value];
                            }
                            // Special cases for dropdown title value
                            if (key === 'title') {
                                if (value === 2 || value === 3) { // we don't need TITLE_MR_LABEL and TITLE_MRS_LABEL anymore, but we still can receive it from BE for old users, therefore we need to skip this 2 values
                                    value = null;
                                }
                                else {
                                    value = TITLES.find(({ value: titleValue }) => {
                                        return value === titleValue;
                                    });
                                }
                            }
                            if (key === 'country') {
                                value = { value: value.id, label: value.name };
                            }
                            if (key === 'phoneMain' && !!value) {
                                form.$(`${parentFieldName}.phoneMain.phoneNumber`).set(value);
                                return;
                            }
                            form.$(`${parentFieldName}.${key}`).set(value);
                            // Re-validate each field that was changed
                            // to prevent having invalid state on valid field
                            form.$(`${parentFieldName}.${key}`).validate();
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "getPrivateDataFromUserProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { profileStore, appStore } = this.props;
                appStore.getCountries()
                    .then((countries) => {
                    const options = countries.map((country) => ({
                        value: country.id,
                        label: country.name
                    }));
                    PrivateAddressForm.$('privateAddress.country').set('extra', options);
                    DeliveryAddressForm.$('deliveryAddress.country').set('extra', options);
                    return options;
                })
                    .then(() => {
                    return profileStore.getFullUserProfile();
                })
                    .then((response) => {
                    const profile = response.profile;
                    const permissions = response.permissions;
                    ContactDetailsForm.$('privateAddress.email').set(profile.email);
                    ContactDetailsForm.$('privateAddress.birthday').set(profile.birthday);
                    this.setValuesInFormFieldsOnInit(ContactDetailsForm, profile);
                    this.setValuesInFormFieldsOnInit(PrivateAddressForm, profile);
                    this.setValuesInFormFieldsOnInit(DeliveryAddressForm, profile);
                    // Set values of the user permissions into the form
                    Object.keys(permissions).forEach((key) => {
                        const value = permissions[key];
                        // only the form's own fields — the response may carry more (e.g. consent dates)
                        if (DataUsageForm.has(key))
                            DataUsageForm.$(key).set(value);
                    });
                    this.updatePhoneInForm();
                    saveAccountBaseline();
                    this.setState({ isPageLoaded: false });
                });
            }
        });
        // ADV-268: on mobile the tab bar scrolls sideways; keep the active tab fully in view
        // (8px = the bar's side padding), e.g. DATENNUTZUNG, which is cut off at 390px
        Object.defineProperty(this, "scrollActiveTabIntoView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const strip = this.tabsRef.current;
                const tab = strip && strip.children[this.state.activeTab];
                if (!tab)
                    return;
                const bar = strip.getBoundingClientRect();
                const rect = tab.getBoundingClientRect();
                if (rect.right > bar.right - 8)
                    strip.scrollLeft += rect.right - bar.right + 8;
                else if (rect.left < bar.left + 8)
                    strip.scrollLeft -= bar.left + 8 - rect.left;
            }
        });
        Object.defineProperty(this, "checkShouldUpdatePhoneInForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, typeAddress, id) => {
                const { profileStore } = this.props;
                if (typeAddress === 'deliveryAddress') {
                    const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                    const getCurrentDeliveryAddress = !!getDeliveryAddreses && getDeliveryAddreses.find((item) => item.id === id);
                    const deliveryPhone = _get(getCurrentDeliveryAddress, 'phoneMain', false);
                    const deliveryPhoneInForm = form.$('deliveryAddress.phoneMain').value.phoneNumber;
                    if (deliveryPhone !== deliveryPhoneInForm) {
                        this.updatePhoneInForm(); // check if filled phoneNumber in 3 fields, and then switch to 1 field
                    }
                }
                else {
                    const privatePhone = _get(profileStore, 'userProfile.privateAddress.phoneMain', '');
                    const privatePhoneInForm = form.$('privateAddress.phoneMain').value.phoneNumber;
                    if (privatePhone !== privatePhoneInForm) {
                        this.updatePhoneInForm(); // check if filled phoneNumber in 3 fields, and then switch to 1 field
                    }
                }
            }
        });
        Object.defineProperty(this, "updatePhoneInForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const { profileStore } = this.props;
                const privatePhone = _get(profileStore, 'userProfile.privateAddress.phoneMain', '');
                const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const getCurrentDeliveryAddress = !!getDeliveryAddreses && getDeliveryAddreses.find((item) => item.id === id);
                const deliveryPhone = _get(getCurrentDeliveryAddress, 'phoneMain', false);
                ContactDetailsForm.$('privateAddress.phoneMain').set('rules', {
                    countryCode: privatePhone ? '' : 'required',
                    areaCode: privatePhone ? '' : 'required|phone_areaCode',
                    phoneNumber: privatePhone ? 'required|phone' : 'required|phone_phoneNumber'
                });
                PrivateAddressForm.$('privateAddress.phoneMain').set('rules', {
                    countryCode: privatePhone ? '' : 'required',
                    areaCode: privatePhone ? '' : 'required|phone_areaCode',
                    phoneNumber: privatePhone ? 'required|phone' : 'required|phone_phoneNumber'
                });
                DeliveryAddressForm.$('deliveryAddress.phoneMain').set('rules', {
                    countryCode: deliveryPhone ? '' : 'required',
                    areaCode: deliveryPhone ? '' : 'required|phone_areaCode',
                    phoneNumber: deliveryPhone ? 'required|phone' : 'required|phone_phoneNumber'
                });
                if (!!privatePhone) {
                    ContactDetailsForm.$('privateAddress.phoneMain').set('value', {
                        countryCode: '',
                        areaCode: '',
                        phoneNumber: privatePhone
                    });
                    PrivateAddressForm.$('privateAddress.phoneMain').set('value', {
                        countryCode: '',
                        areaCode: '',
                        phoneNumber: privatePhone
                    });
                }
                if (!!deliveryPhone) {
                    DeliveryAddressForm.$('deliveryAddress.phoneMain').set('value', {
                        countryCode: '',
                        areaCode: '',
                        phoneNumber: deliveryPhone
                    });
                }
                ContactDetailsForm.validate();
            }
        });
        Object.defineProperty(this, "onPasswordConfirm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { notificationStore, authStore, profileStore } = this.props;
                CredentialsForm.submit()
                    .then(() => {
                    const oldPasswordField = CredentialsForm.$('oldPassword');
                    const passwordField = CredentialsForm.$('changePassword.password');
                    if (passwordField.changed) {
                        this.setState({ isChangePassword: true });
                        return authStore.changePassword(oldPasswordField.value, passwordField.value)
                            .then(() => {
                            profileStore.getProfileData();
                            this.setState({ activeTab: 1 });
                        })
                            .finally(() => {
                            CredentialsForm.state.options.set({ validateOnChange: false });
                            CredentialsForm.clear(); // or form.reset()
                            CredentialsForm.state.options.set({ validateOnChange: true });
                            this.setState({ isChangePassword: false });
                        });
                    }
                })
                    .catch((err) => {
                    const { errors } = err;
                    // err is either an Error instance or an array with errors from BE
                    const formattedError = _get(errors, '[0].detail', err);
                    notificationStore.addNotification({
                        message: formattedError,
                        level: 'error'
                    });
                });
            }
        });
        Object.defineProperty(this, "onPasswordDecline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                CredentialsForm.reset();
            }
        });
        Object.defineProperty(this, "onContactsDecline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                // ContactDetailsForm.reset(); TODO: needs prepare skeleton logic for correct rerender fields
                this.getPrivateDataFromUserProfile();
            }
        });
        Object.defineProperty(this, "onContactsSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { notificationStore } = this.props;
                ContactDetailsForm.submit()
                    .then((form) => this.checkShouldUpdatePhoneInForm(form))
                    .catch((err) => {
                    const { errors } = err;
                    // err is either an Error instance or an array with errors from BE
                    const formattedError = _get(errors, '[0].detail', err);
                    notificationStore.addNotification({
                        message: formattedError,
                        level: 'error'
                    });
                });
            }
        });
        Object.defineProperty(this, "onAddressesSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (typeAddress, id) => {
                const { notificationStore, profileStore, t } = this.props;
                const form = typeAddress === 'deliveryAddress' ? DeliveryAddressForm : PrivateAddressForm;
                form.submit()
                    .then((form) => {
                    const values = form.values();
                    const getCurrentAddressData = _get(values, [typeAddress], null);
                    this.setState({ isPageLoaded: true });
                    return profileStore.updateUserProfileData({ [typeAddress]: getCurrentAddressData })
                        .then(() => profileStore.getProfileData())
                        .then(() => {
                        this.checkShouldUpdatePhoneInForm(form, typeAddress, id);
                        this.setState({ isPageLoaded: false });
                    })
                        .catch((error) => {
                        const { errors } = error;
                        console.log('errors', error);
                        // TODO: Install jsonapi de-serialaizer and use it everywhere in app.
                        // TODO: Move this part of code somewhere to the upper level of the abstraction
                        if (errors) {
                            errors.forEach((error) => {
                                if (error.status === '500') {
                                    notificationStore.addNotification({
                                        message: t('Notifications:errors.serverError'),
                                        level: 'error'
                                    });
                                    return;
                                }
                                const pointer = error.source && error.source.pointer;
                                const invalidationText = error.detail;
                                if (!pointer)
                                    return;
                                const fieldName = pointer.split('/')[(pointer.split('/').length - 1)];
                                if (pointer.indexOf('privateAddress') >= 0) {
                                    notificationStore.addNotification({
                                        message: `Contact Address ${fieldName} - ${invalidationText}`
                                    });
                                    form.$(`privateAddress.${fieldName}`).invalidate(invalidationText);
                                }
                                if (pointer.indexOf('deliveryAddress') >= 0) {
                                    notificationStore.addNotification({
                                        message: `Delivery Address ${fieldName} - ${invalidationText}`
                                    });
                                    form.$(`deliveryAddress.${fieldName}`).invalidate(invalidationText);
                                }
                            });
                            return;
                        }
                        // TODO: handle jsonapi validation errors
                        // when CORS issues fixed.
                        // TODO: install some jsonapi client library
                        notificationStore.addNotification({
                            message: t('Notifications:errors.validationError')
                        });
                        this.setState({ isPageLoaded: false });
                    });
                })
                    .catch((err) => {
                    const { errors } = err;
                    // err is either an Error instance or an array with errors from BE
                    const formattedError = _get(errors, '[0].detail', err);
                    notificationStore.addNotification({
                        message: formattedError,
                        level: 'error'
                    });
                    this.setState({ isPageLoaded: false });
                });
            }
        });
        Object.defineProperty(this, "onContactsModalSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                ContactDetailsForm.validate({ showErrors: true })
                    .then((form) => {
                    if (form.isValid) {
                        this.onContactsSave();
                    }
                    else {
                        console.log('Form errors', form.errors());
                    }
                });
            }
        });
        Object.defineProperty(this, "onAddressesModalSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (typeAddress, id) => {
                const form = typeAddress === 'deliveryAddress' ? DeliveryAddressForm : PrivateAddressForm;
                form.validate({ showErrors: true })
                    .then((form) => {
                    if (form.isValid) {
                        this.onAddressesSave(typeAddress, id);
                        this.setState({ addressModal: null });
                    }
                    else {
                        console.log('Form errors 3', form.errors());
                    }
                });
            }
        });
        Object.defineProperty(this, "onDeleteAccount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, appStore, notificationStore, authStore, profileStore: { disableProfile } } = this.props;
                const { getIdToken, clearUserState } = authStore;
                const { hideModal, showModal } = appStore;
                const { addNotification } = notificationStore;
                const modalProps = {
                    t,
                    className: 'pf-modal',
                    showCloseButton: false,
                    onDecline: () => hideModal('CONFIRM_ACCOUNT_DELETE_MODAL'),
                    onAccept: () => {
                        getIdToken().then((token) => {
                            disableProfile(token);
                            clearUserState();
                        });
                        // addNotification({
                        //   message: t('Notifications:errors.stillInDevelopment'),
                        //   level: 'warning'
                        // });
                        hideModal('CONFIRM_ACCOUNT_DELETE_MODAL');
                    }
                };
                showModal('CONFIRM_ACCOUNT_DELETE_MODAL', modalProps);
            }
        });
        Object.defineProperty(this, "setValuesToFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (typeAddress, id) => {
                const { profileStore } = this.props;
                if (typeAddress === 'deliveryAddress') {
                    const value = _get(profileStore, 'userProfile.deliveryAddresses', null);
                    const item = value.find((item) => item.id === id);
                    const values = DeliveryAddressForm.values();
                    Object.keys(values).forEach((parentFieldName) => {
                        Object.keys(values[parentFieldName]).forEach((key) => {
                            let value = item[key];
                            if (key === 'gender') {
                                value = GENDERS[value];
                            }
                            // Special cases for dropdown title value
                            if (key === 'title') {
                                value = TITLES[value];
                            }
                            if (key === 'country') {
                                value = value ? { value: value.id, label: value.name } : null;
                            }
                            if (key === 'phoneMain' && !!value) {
                                DeliveryAddressForm.$(`deliveryAddress.phoneMain.phoneNumber`).set(value);
                                return;
                            }
                            DeliveryAddressForm.$(`deliveryAddress.${key}`).set(value);
                            DeliveryAddressForm.$(`deliveryAddress.${key}`).validate();
                        });
                    });
                    this.updatePhoneInForm(id);
                }
            }
        });
        Object.defineProperty(this, "resetValidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, typeAddress) => {
                return form.each((field) => {
                    form.state.options.set({ validateOnChange: false });
                    field.clear();
                    field.resetValidation(true);
                    form.$(`${typeAddress}.phoneMain.countryCode`).set('value', '+49');
                    form.state.options.set({ validateOnChange: true });
                });
            }
        });
        Object.defineProperty(this, "onContactsEdit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (typeAddress, id) => {
                const { profileStore } = this.props;
                const profile = _get(profileStore, 'userProfile', null);
                const privatePhone = _get(profileStore, 'userProfile.privateAddress.phoneMain', false);
                const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const getCurrentDeliveryAddress = !!getDeliveryAddreses && getDeliveryAddreses.find((item) => item.id === id);
                const deliveryPhone = _get(getCurrentDeliveryAddress, 'phoneMain', false);
                const hasPhone = typeAddress === 'privateAddress' ? !!privatePhone : !!deliveryPhone;
                if (typeAddress === 'deliveryAddress') {
                    this.resetValidation(DeliveryAddressForm, typeAddress);
                    if (id) {
                        this.setValuesToFields(typeAddress, id);
                    }
                }
                else {
                    this.resetValidation(PrivateAddressForm, typeAddress);
                    this.setValuesInFormFieldsOnInit(PrivateAddressForm, profile);
                }
                // ADV-268: the md3 dialog rendered by this page (ProfileAddressModal), no longer the global
                // CONTACT_DATA_MODAL
                this.setState({ addressModal: { typeAddress, id, hasPhone } });
            }
        });
        Object.defineProperty(this, "onAddressModalDecline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { addressModal } = this.state;
                if (addressModal) {
                    // the form of the address being edited (this used to reset DeliveryAddressForm with the
                    // billing address path as well, which threw and left the dialog open)
                    const form = addressModal.typeAddress === 'deliveryAddress' ? DeliveryAddressForm : PrivateAddressForm;
                    this.resetValidation(form, addressModal.typeAddress);
                }
                this.setState({ addressModal: null });
            }
        });
        Object.defineProperty(this, "renderAddressModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                const { addressModal } = this.state;
                if (!addressModal)
                    return null;
                const { typeAddress, id, hasPhone } = addressModal;
                return (React.createElement(ProfileAddressModal, { t: t, typeAddress: typeAddress, hasPhone: hasPhone, form: typeAddress === 'deliveryAddress' ? DeliveryAddressForm : PrivateAddressForm, onConfirm: () => this.onAddressesModalSave(typeAddress, id), onDecline: this.onAddressModalDecline }));
            }
        });
        Object.defineProperty(this, "onTabSelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, index) => this.setState(() => ({
                activeTab: index
            }))
        });
        // ADV-268: Figma "Konto / Tab" — text-only tabs (uppercase via ProfilePage.css), no icons
        Object.defineProperty(this, "renderTabs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                const ProfileTabs = [
                    { name: t('dashboard.tabTitleAccount'), icon: 'accountIcon' },
                    { name: t('dashboard.tabTitleSecurity'), icon: 'securityIcon' },
                    { name: t('dashboard.tabTitleAddress'), icon: 'addressIcon' },
                    { name: t('dashboard.tabTitleDataUsage'), icon: 'dataUsageIcon' }
                ];
                return ProfileTabs.map(({ name, icon }, index) => (React.createElement("button", { type: 'button', role: 'tab', "aria-controls": 'tabpanel-setting', "aria-selected": this.state.activeTab === index, className: classNames('pf-tab', { 'is-active': this.state.activeTab === index }), id: `tabpanel-setting-${icon}`, key: name, onClick: (event) => this.onTabSelect(event, index) }, name)));
            }
        });
        Object.defineProperty(this, "renderTabPanels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, profileStore, appStore } = this.props;
                const { isPageLoaded, isChangePassword } = this.state;
                const privatePhone = _get(profileStore, 'userProfile.privateAddress.phoneMain', false);
                const AccountTab = ProfileTabAccountNext;
                const SecurityTab = ProfileTabSecurityNext;
                const DataUsageTab = ProfileTabDataUsageNext;
                const TabPanels = [
                    {
                        name: t('dashboard.tabTitleAccount'),
                        component: (React.createElement(AccountTab, { t: t, isPageLoaded: isPageLoaded, hasPhone: !!privatePhone, onDeleteAccount: this.onDeleteAccount, onDecline: this.onContactsDecline, onConfirm: this.onContactsModalSave })),
                        className: 'pf-panel pf-account'
                    },
                    {
                        name: t('dashboard.tabTitleSecurity'),
                        component: (React.createElement(SecurityTab, { t: t, isChangePassword: isChangePassword, onDecline: this.onPasswordDecline, onConfirm: this.onPasswordConfirm })),
                        className: 'pf-panel pf-security'
                    },
                    {
                        name: t('dashboard.tabTitleAddress'),
                        component: (React.createElement(ProfileTabAddress, { t: t, profileStore: profileStore, renderAddressData: this.renderAddressData, onContactsEdit: this.onContactsEdit })),
                        className: 'pf-panel pf-address'
                    },
                    {
                        name: t('dashboard.tabTitleDataUsage'),
                        component: React.createElement(DataUsageTab, { t: t, language: appStore.language, permissions: profileStore.userPermissions }),
                        className: 'pf-panel pf-datausage'
                    }
                ];
                return TabPanels.map((panel, index) => (React.createElement(TabPanel, { value: this.state.activeTab, key: panel.name, index: index, className: panel.className }, panel.component)));
            }
        });
        Object.defineProperty(this, "renderAddressValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                const { t } = this.props;
                if (!!value) {
                    return React.createElement("span", { className: 'pf-addr-value' }, value);
                }
                else {
                    return React.createElement("span", { className: 'pf-addr-required' }, t('dashboard.required'));
                }
            }
        });
        Object.defineProperty(this, "renderSkeleton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                const { isPageLoaded } = this.state;
                if (!isPageLoaded) {
                    return value;
                }
                else {
                    return React.createElement(Skeleton, { animation: 'wave', variant: 'text', width: Math.floor(Math.random() * 200), className: styles.skeletonItem });
                }
            }
        });
        Object.defineProperty(this, "onRemoveDeliveryAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, form, typeAddress) => {
                const { t, notificationStore, appStore, profileStore } = this.props;
                const { hideModal, showModal } = appStore;
                const modalProps = {
                    t,
                    className: 'pf-modal',
                    showCloseButton: false,
                    onDecline: () => hideModal('CONFIRM_DELIVERY_ADDRESS_DELETE_MODAL'),
                    onAccept: () => {
                        this.setState({ isPageLoaded: true });
                        profileStore.removeDeliveryAddressData(id)
                            .then(() => {
                            this.checkShouldUpdatePhoneInForm(form, typeAddress, id);
                            this.setState({ isPageLoaded: false });
                        })
                            .catch((err) => {
                            notificationStore.addNotification({
                                message: `${err}`,
                                level: 'error'
                            });
                            console.log('err', err);
                            this.setState({ isPageLoaded: false });
                        });
                        hideModal('CONFIRM_DELIVERY_ADDRESS_DELETE_MODAL');
                    }
                };
                showModal('CONFIRM_DELIVERY_ADDRESS_DELETE_MODAL', modalProps);
            }
        });
        // ADV-268 — Figma "Konto / Adresskarte" (Typ "Ohne Standard"): title, rule, six label/value rows,
        // the edit action. Delivery cards keep their delete action in the head (Figma has none; the
        // 26px icon button keeps the head at the title's line height). Same values, "required"
        // markers, skeletons and handlers as before; a missing billing address is ProfileTabAddress's
        // add tile.
        Object.defineProperty(this, "renderAddressData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, typeAddress) => {
                const { t, profileStore, appStore: { language } } = this.props;
                if (!data)
                    return null;
                const getAddressData = _pick(data, ['id', 'firstName', 'lastName', 'street', 'number', 'zip', 'city', 'country', 'phoneMain']);
                const onCheckOnEmptyValue = _pick(data, ['firstName', 'lastName', 'street', 'number', 'zip', 'city', 'phoneMain']);
                const isEmptyValue = Object.values(onCheckOnEmptyValue).some(_isEmpty);
                const countryAllNames = _get(data, 'country.allNames', '');
                const email = _get(profileStore, 'userProfile.email', '');
                const fullName = `${getAddressData.firstName} ${getAddressData.lastName}`;
                const rows = [
                    { key: 'name', value: getAddressData.lastName ? fullName : null },
                    { key: 'email', value: email || null },
                    { key: 'address', value: getAddressData.street ? `${getAddressData.street} ${getAddressData.number}` : null },
                    { key: 'city', value: getAddressData.city ? `${getAddressData.zip} ${getAddressData.city}` : null },
                    { key: 'country', value: getAddressData.country ? countryAllNames[language] : null },
                    { key: 'phone', value: getAddressData.phoneMain || null }
                ];
                return (React.createElement("div", { className: 'pf-addr', key: getAddressData.id },
                    React.createElement("div", { className: 'pf-addr-head' },
                        React.createElement("h3", { className: 'pf-addr-title' }, t(`dashboard.${typeAddress}`)),
                        typeAddress === 'deliveryAddress' && (React.createElement("button", { type: 'button', className: 'pf-addr-remove', "aria-label": t('addressCard.remove'), onClick: () => this.onRemoveDeliveryAddress(getAddressData.id, DeliveryAddressForm, typeAddress) },
                            React.createElement(MIcon, { name: 'trash-2', size: 18 })))),
                    React.createElement("hr", { className: 'pf-addr-line' }),
                    React.createElement("dl", { className: 'pf-addr-rows' }, rows.map(({ key, value }) => (React.createElement("div", { className: 'pf-addr-row', key: key },
                        React.createElement("dt", null, t(`addressCard.${key}`)),
                        React.createElement("dd", null, this.renderSkeleton(this.renderAddressValue(value))))))),
                    React.createElement("div", { className: 'pf-addr-action' },
                        React.createElement("button", { type: 'button', className: classNames('pf-btn', isEmptyValue ? 'pf-btn--danger' : 'pf-btn--outlined'), onClick: () => this.onContactsEdit(typeAddress, getAddressData.id) }, isEmptyValue ? t('dashboard.completeAddress') : t('addressCard.edit')))));
            }
        });
        this.state = {
            credentialsSubmitting: false,
            contactsSubmitting: false,
            dataUsageSubmitting: false,
            isRequired: false,
            isPageLoaded: true,
            isChangePassword: false,
            error: '',
            activeTab: 0,
            addressModal: null
        };
    }
    componentDidMount() {
        this.getPrivateDataFromUserProfile();
        const getActiveTab = localStorage.getItem('profileTab');
        const activeTab = getActiveTab ? Number(getActiveTab) : 0;
        this.setState({ activeTab });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab)
            this.scrollActiveTabIntoView();
    }
    componentWillUnmount() {
        ContactDetailsForm.reset();
        clearAccountBaseline();
        CredentialsForm.state.options.set({ validateOnChange: false });
        CredentialsForm.clear(); // or form.reset()
        CredentialsForm.state.options.set({ validateOnChange: true });
        DataUsageForm.reset();
        PrivateAddressForm.reset();
        DeliveryAddressForm.reset();
        localStorage.removeItem('profileTab');
    }
    render() {
        // ADV-268 — Figma "KONTO | 06 Profil": breadcrumb back to the dashboard, then one card with the
        // tab bar and the active tab (page-local styles: ./ProfilePage.css). The tab panels and their
        // handlers are unchanged.
        const { t } = this.props;
        return (React.createElement(Page, { page: 'PROFILE_SETTINGS', mainContentClass: 'pf-main' },
            React.createElement("div", { className: 'md3' },
                React.createElement("div", { className: 'pf-page' },
                    React.createElement("nav", { className: 'pf-crumbs', "aria-label": t('crumbs.label') },
                        React.createElement(Link, { className: 'pf-crumb-link', to: '/account/dashboard' }, t('crumbs.dashboard')),
                        React.createElement("img", { className: 'pf-crumb-sep', src: breadcrumbChevron, alt: '', width: 14, height: 14 }),
                        React.createElement("img", { className: 'pf-crumb-sep pf-crumb-sep--sm', src: breadcrumbChevronSm, alt: '', width: 13, height: 13 }),
                        React.createElement("h1", { className: 'pf-crumb-current', "aria-current": 'page' }, t('crumbs.profile'))),
                    React.createElement("div", { className: 'pf-card' },
                        React.createElement("div", { role: 'tablist', className: 'pf-tabs', ref: this.tabsRef }, this.renderTabs()),
                        this.renderTabPanels())),
                this.renderAddressModal())));
    }
};
SettingsPage = __decorate([
    inject('authStore', 'appStore', 'profileStore', 'notificationStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], SettingsPage);
export default translate(['SettingsPage', 'modals', 'common'])(SettingsPage);
